// extracted by mini-css-extract-plugin
export default {"subtitle":"Feedback_subtitle__BnclX","descriptionContainer":"Feedback_descriptionContainer__4ed8K","formInput":"Feedback_formInput__C37Zd","backLink":"Feedback_backLink__N8xaX"};